import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { mainProfile, update_profile, update_exp, update_edu, update_qualification, update_portfolio, delete_portfolio, update_bio, send_mobile_otp, verify_mobile_otp, resend_mobile_otp, profile_img_update, createfreelancerAvailability } from '../../Apis';
import axios from 'axios';


export const GetProfile = createAsyncThunk('profileeee', async ({ id, token, profileType }, { rejectWithValue }) => {
    try {
        const response = await mainProfile(id, token, profileType);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
// export const GetProfile = createAsyncThunk('profileeee', async ({ id, token }, { rejectWithValue }) => {
//     try {
//         if (id) {
//             axios.post("")
//         }
//     } catch (error) {
//         return rejectWithValue(error.response);
//     }
// });


export const UpProfile = createAsyncThunk('UpProfile', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_profile(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


//submit profile data 
export const UpdateBioProfile = createAsyncThunk('UpdateBioProfile', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_bio(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const UpdateExperience = createAsyncThunk('UpdateExperience', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_exp(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const UpdateEducation = createAsyncThunk('UpdateEducation', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_edu(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const UpdateQualification = createAsyncThunk('UpdateQualification', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_qualification(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const UpdatePortfolio = createAsyncThunk('UpdatePortfolio', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_portfolio(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const DeletePortfolio = createAsyncThunk('DeletePortfolio', async ({ id, token }, { rejectWithValue }) => {
    try {
        const response = await delete_portfolio(id, token);
        return { response, id };
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const SendMobileOtp = createAsyncThunk('SendMobileOtp', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await send_mobile_otp(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const VerifyMobileOtp = createAsyncThunk('VerifyMobileOtp', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await verify_mobile_otp(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const ResendMobileOtp = createAsyncThunk('ResendMobileOtp', async (token, { rejectWithValue }) => {
    try {
        const response = await resend_mobile_otp(token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const ProfileImgUp = createAsyncThunk('profileImgUp', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await profile_img_update(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CreatefreelancerAvailability = createAsyncThunk('CreatefreelancerAvailability', async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await createfreelancerAvailability(token, formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

// export const  

const getUpdatedProfileItem = (payload) => {
    const responseData = payload?.data?.data || payload?.data || payload;
    if (!responseData || typeof responseData !== "object") return null;
    return responseData.data && typeof responseData.data === "object" ? responseData.data : responseData;
};

const upsertProfileItem = (items, item) => {
    if (!item || !item.id) return items;
    const index = items.findIndex(existing => existing.id == item.id);
    if (index >= 0) {
        items[index] = { ...items[index], ...item };
    } else {
        items.push(item);
    }
    return items;
};



const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        loading: false,
        error: null,
        success: false,
        error2: null,
        success2: false,
        error3: null,
        success3: false,
        profile: {},
        portfolio: [],
        reviews: [],
        resume: [],
        education: [],
        qualification: [],
        mobileOtp: ""

    },
    reducers: {
        clearProfileStatus: state => {
            state.success = false;
            state.error = null;

        },
        clearUpStatus: state => {
            state.error2 = null;
            state.success2 = false;
            state.error3 = null;
            state.success3 = false;
        },

        clearOtp: state => {
            state.mobileOtp = ""
        },
    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(GetProfile.pending, state => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.profile = {};
                state.education = [];
                state.resume = [];
                state.qualification = [];
                state.portfolio = [];
                state.reviews = [];
            })
            .addCase(GetProfile.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload?.data?.success === false) {
                    state.success = false;
                    state.error = action.payload;
                    state.profile = {};
                    state.education = [];
                    state.resume = [];
                    state.qualification = [];
                    state.portfolio = [];
                    state.reviews = [];
                    return;
                }

                state.success = action.payload;
                state.error = null;
                const profileData = action.payload.data.data || {};
                state.profile = profileData;
                state.education = Array.isArray(profileData.education) ? profileData.education : [];
                state.resume = Array.isArray(profileData.experience) ? profileData.experience : [];
                state.qualification = Array.isArray(profileData.qualification) ? profileData.qualification : [];
                state.portfolio = Array.isArray(profileData.portfolio) ? profileData.portfolio : [];
                state.reviews = Array.isArray(profileData.reviews) ? profileData.reviews : [];
            })
            .addCase(GetProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
                state.profile = {};
                state.education = [];
                state.resume = [];
                state.qualification = [];
                state.portfolio = [];
                state.reviews = [];
            })
            // add 
            .addCase(UpdateExperience.pending, state => {
                state.error = null;
                state.error2 = null;
                state.success = false;
                state.success2 = false;
            })
            .addCase(UpdateExperience.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.success = action.payload;
                state.error = null;
                state.error2 = null;
                upsertProfileItem(state.resume, getUpdatedProfileItem(action.payload));
            })
            .addCase(UpdateExperience.rejected, (state, action) => {
                state.error = action.payload;
                state.error2 = action.payload;
                state.success = false;
                state.success2 = false;
            })

            .addCase(UpdateEducation.pending, state => {
                state.error = null;
                state.error2 = null;
                state.success = false;
                state.success2 = false;
            })
            .addCase(UpdateEducation.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.success = action.payload;
                state.error = null;
                state.error2 = null;
                upsertProfileItem(state.education, getUpdatedProfileItem(action.payload));
            })
            .addCase(UpdateEducation.rejected, (state, action) => {
                state.error = action.payload;
                state.error2 = action.payload;
                state.success = false;
                state.success2 = false;
            })
            .addCase(UpdateQualification.pending, state => {
                state.error = null;
                state.error2 = null;
                state.success = false;
                state.success2 = false;
            })
            .addCase(UpdateQualification.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.success = action.payload;
                state.error = null;
                state.error2 = null;
                upsertProfileItem(state.qualification, getUpdatedProfileItem(action.payload));
            })
            .addCase(UpdateQualification.rejected, (state, action) => {
                state.error = action.payload;
                state.error2 = action.payload;
                state.success = false;
                state.success2 = false;
            })

            .addCase(UpdatePortfolio.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(UpdatePortfolio.fulfilled, (state, action) => {
                state.success = action.payload;
                state.success2 = action.payload;
                state.error = null;
                state.error2 = null;
            })
            .addCase(UpdatePortfolio.rejected, (state, action) => {
                state.error = action.payload;
                state.error2 = action.payload;
                state.success = false;
                state.success2 = false;
            })

            .addCase(DeletePortfolio.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(DeletePortfolio.fulfilled, (state, action) => {
                state.success = action.payload.response;
                state.error = null;
                state.portfolio = state.portfolio.filter((item) => String(item?.id ?? item?.portfolio_id ?? item?.freelance_portfolio_id ?? item?.portfolioId) !== String(action.payload.id));
            })
            .addCase(DeletePortfolio.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

            .addCase(UpdateBioProfile.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(UpdateBioProfile.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(UpdateBioProfile.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(SendMobileOtp.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(SendMobileOtp.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;
                state.mobileOtp = action.payload.data.mobile_otp;
            })
            .addCase(SendMobileOtp.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })

            .addCase(VerifyMobileOtp.pending, state => {
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(VerifyMobileOtp.fulfilled, (state, action) => {
                state.success3 = action.payload;
                state.error3 = null;
            })
            .addCase(VerifyMobileOtp.rejected, (state, action) => {
                state.error3 = action.payload;
                state.success3 = false;
            })

            .addCase(ResendMobileOtp.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(ResendMobileOtp.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;
                state.mobileOtp = action.payload.data.mobile_otp;

            })
            .addCase(ResendMobileOtp.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(UpProfile.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(UpProfile.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;

            })
            .addCase(UpProfile.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(ProfileImgUp.pending, state => {
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(ProfileImgUp.fulfilled, (state, action) => {
                state.success3 = action.payload;
                state.error3 = null;

            })
            .addCase(ProfileImgUp.rejected, (state, action) => {
                state.error3 = action.payload;
                state.success3 = false;
            })
            .addCase(CreatefreelancerAvailability.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CreatefreelancerAvailability.fulfilled, (state, action) => {
                state.success = action.payload
                state.error = null;

            })
            .addCase(CreatefreelancerAvailability.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearProfileStatus, clearUpStatus, clearOtp } = profileSlice.actions;
export default profileSlice.reducer;
